import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { AccountPerformanceDocument } from './graphql/accountPerformance.generated';

type Props = { accountId: string };

export const AccountPerformanceCard: React.FC<Props> = ({ accountId }) => {
  const { data } = useGraphQLQuery(AccountPerformanceDocument, { variables: { id: accountId }, throwOnError: true });

  if (!data) return <CardLoader />;

  const { account } = data;
  if (!('performance' in account)) return null;

  const { icon, name } = account;

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <Box css={{ display: 'flex', gap: 'space.200', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box css={{ display: 'flex', gap: 'space.150' }}>
            <ThemedImage themedAsset={icon} alt={name} css={{ width: 'size.450', height: 'size.450' }} />
            <Heading as="h3" variant="title300">
              {name}
            </Heading>
          </Box>
        </Box>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300' }}>Performance content placeholder</Card.Content>
    </Card>
  );
};
